import React, { forwardRef, Ref } from "react";
import {
  IconButton as ChackraIconButton,
  IconButtonProps,
} from "@chakra-ui/button";

/**
 * `IconButton` 컴포넌트에 대한 설명을 추가합니다.
 */
export const IconButtonUnstyled = forwardRef(
  (props: IconButtonProps, ref: Ref<HTMLButtonElement>) => {
    const { children, ...rest } = props;

    return (
      <ChackraIconButton
        variant="unstyled"
        minWidth="auto"
        height="auto"
        borderWidth={0}
        {...rest}
        ref={ref}
      >
        {children}
      </ChackraIconButton>
    );
  },
);
